import * as yup from 'yup'
import { cpf, cnpj } from 'cpf-cnpj-validator'
import { phoneValidator } from '../../shared/utils/validators'
import { creditCardType } from '../../shared/utils/creditCardType'

import i18n from 'i18next'

const formSchema = (isNational: boolean) => {
	return yup.object({
		email: yup
			.string()
			.required(() => i18n.t('form:ERRORS.EMAIL_REQUIRED'))
			.email(() => i18n.t('form:ERRORS.EMAIL_INVALID')),

		hasPassword: yup.boolean().required(),

		/*password: yup.string().min(6, () => i18n.t('form:ERRORS.PASSWORD_MIN_LENGTH')),
		confirmPassword: yup
			.string()
			.oneOf(
				[yup.ref('password'), null],
				() => i18n.t('form:ERRORS.PASSWORD_DONOT_MATCH')
			)
			.min(6, () => i18n.t('form:ERRORS.PASSWORD_MIN_LENGTH')),*/

		password: yup.string().when('hasPassword', {
			is: true,
			then: schema =>
				schema
				.required(() => i18n.t('form:ERRORS.PASSWORD_REQUIRED'))
				.min(6, () => i18n.t('form:ERRORS.PASSWORD_MIN_LENGTH')),
			otherwise: schema => schema.notRequired(),
		}),
		  
		confirmPassword: yup.string().when('hasPassword', {
			is: true,
			then: schema =>
				schema
				.required(() => i18n.t('form:ERRORS.CONFIRM_PASSWORD_REQUIRED'))
				.oneOf(
				[yup.ref('password')],
				() => i18n.t('form:ERRORS.PASSWORD_DONOT_MATCH')
				),
			otherwise: schema => schema.notRequired(),
		}),

		name: yup.string().required(() => i18n.t('form:ERRORS.FIELDS_REQUIRED')),

		birthdate: yup.date()
			.required('Birthdate is required')
			.typeError(() => i18n.t('form:ERRORS.INVALID_DATE')),

		zipcode: yup
			.string()
			.required(() => i18n.t('form:ERRORS.FIELDS_REQUIRED'))
			.min(4, () => i18n.t('form:ERRORS.INVALID_VALUE'))
			.max(9, () => i18n.t('form:ERRORS.INVALID_VALUE')),

		address: yup.string().required(() => i18n.t('form:ERRORS.FIELDS_REQUIRED')),

		number: yup.string().typeError(() => i18n.t('form:ERRORS.INVALID_VALUE')).when([], {
			is: () => isNational, // conditional
			then: yup.string().required(i18n.t('form:ERRORS.FIELDS_REQUIRED')).min(1, () => i18n.t('form:ERRORS.SHOT_VALUE')), // if condition is true
			otherwise: yup.string(), // if condition is false
		}),

		district: yup.string().when([], {
			is: () => isNational, // conditional
			then: yup.string().required(i18n.t('form:ERRORS.FIELDS_REQUIRED')), // if condition is true
			otherwise: yup.string(), // if condition is false
		}),

		complement: yup.string(),

		city: yup.string().required(() => i18n.t('form:ERRORS.FIELDS_REQUIRED')),

		state: yup.string().required(() => i18n.t('form:ERRORS.FIELDS_REQUIRED')),

		payment: yup.string().required(() => i18n.t('form:ERRORS.FIELDS_REQUIRED')),

		voucher: yup.string(),

		termsChecked: yup
			.boolean()
			.required(() => i18n.t('form:ERRORS.TERMS_REQUIRED'))
			.oneOf([true], () => i18n.t('form:ERRORS.TERMS_REQUIRED')),

		document: yup
			.string()
			.required(() => i18n.t('form:ERRORS.FIELDS_REQUIRED'))
			.test(
				'document validation',
				() => i18n.t('form:ERRORS.INVALID_DOCUMENT'),
				(value) => {
					if (!isNational) return true
					if (value) {
						if (cpf.isValid(value) || cnpj.isValid(value)) {
							return true
						}
					}

					return false
				}
			),
		ie: yup
			.string(),
		phone: yup
			.string()
			.required(() => i18n.t('form:ERRORS.FIELDS_REQUIRED'))
			.test('phone validation', () => i18n.t('form:ERRORS.INVALID_PHONE'), (value) => {
				if (!isNational) return true
				if (value) {
					if (phoneValidator(value)) {
						return true
					}
				}

				return false
			}),

		cardNumber: yup
			.string()
			.when('payment', {
				is: 'creditCard',
				then: yup.string().test(
					'card number validation',
					() => i18n.t('form:ERRORS.INVALID_CARD_NUMBER'),
					(value) => {
						value = value?.replace(/\D/g, '');
						if (value) {
							if (creditCardType(value)) {
								return true;
							}
						}
						return false;
					}
				),
				otherwise: yup.string().notRequired(),
			}),

		cardName: yup
			.string()
			.when('payment', {
				is: 'creditCard',
				then: yup.string()
					.min(3, () => i18n.t('form:ERRORS.CARD_NAME_MIN_LENGTH'))
					.test(
						'card name validation',
						() => i18n.t('form:ERRORS.FIELDS_REQUIRED'),
						(value) => {
							if (value && value !== '') {
								return true;
							}
							return false;
						}
					),
				otherwise: yup.string().notRequired(),
			}),

		cardCVV: yup
			.string()
			.when('payment', {
				is: 'creditCard',
				then: yup.string().test(
					'card cvv validation',
					() => i18n.t('form:ERRORS.FIELDS_REQUIRED'),
					(value) => {
						value = value?.replace(/\D/g, '');
						if (value && value !== '') {
							return true;
						}
						return false;
					}
				),
				otherwise: yup.string().notRequired(),
			}),

		cardDate: yup
			.string()
			.when('payment', {
				is: 'creditCard',
				then: yup.string().test(
					'card date validation',
					() => i18n.t('form:ERRORS.FIELDS_REQUIRED'),
					(value) => {
						value = value?.replace(/\D/g, '');
						if (value && value !== '') {
							return true;
						}
						return false;
					}
				),
				otherwise: yup.string().notRequired(),
			}),

		installments: yup.string().typeError(() => i18n.t('form:ERRORS.INVALID_VALUE'))
	})
}

export { formSchema }
